import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomSportsCricket = ({
    color,
    opacity = '1',
    fillOpacity = '1',
    size = 20,
    props,
}: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} {...props} viewBox={`0 0 ${size} ${size}`}>
        <path
            d={
                'M12.5 11.8334L10.1667 14.1667C10 14.3334 9.80558 14.4167 9.58335 14.4167C9.36113 14.4167 9.16669 14.3334 9.00002 14.1667L1.91669 7.08342C1.75002 6.91675 1.66669 6.72925 1.66669 6.52092C1.66669 6.31258 1.75002 6.12508 1.91669 5.95842L4.25002 3.62508C4.41669 3.45841 4.61808 3.37508 4.85419 3.37508C5.0903 3.37508 5.29169 3.45841 5.45835 3.62508L12.5 10.6667C12.6667 10.8334 12.75 11.0279 12.75 11.2501C12.75 11.4723 12.6667 11.6667 12.5 11.8334ZM15.5 18.3334L11.9584 14.7917L13.125 13.6251L16.6667 17.1667L15.5 18.3334ZM15.4167 7.50008C14.6111 7.50008 13.9236 7.21536 13.3542 6.64592C12.7847 6.07647 12.5 5.38897 12.5 4.58341C12.5 3.77786 12.7847 3.09036 13.3542 2.52091C13.9236 1.95147 14.6111 1.66675 15.4167 1.66675C16.2222 1.66675 16.9097 1.95147 17.4792 2.52091C18.0486 3.09036 18.3334 3.77786 18.3334 4.58341C18.3334 5.38897 18.0486 6.07647 17.4792 6.64592C16.9097 7.21536 16.2222 7.50008 15.4167 7.50008Z'
            }
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
